import "./styles/displayError.css";

interface DisplayErrorProps {
	isDisplayError?: boolean;
	errorMsg?: string;
	cssClass?: string;
}

export function DisplayError({ isDisplayError = false, errorMsg = "", cssClass }: DisplayErrorProps) {
	if (!isDisplayError || !errorMsg) return null;

	return (
		<div className={cssClass} id="display-error">
			<h1>Camera error: {errorMsg}</h1>
		</div>
	);
}

export default DisplayError;
